// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ecSk","placeholdersHeader":"styles_placeholdersHeader__1NKMo","editorStyle":"styles_editorStyle__cJWsN","placeholdersBox":"styles_placeholdersBox__1gOvA"};